import React from "react";
import { Link } from "react-router-dom";
import { button } from "components/designTokens";
import c from "classnames";
import * as icons from "components/icons";

export function Form({
  templateList,
  programs,
  pickedPrograms,
  title,
  template,
  onSetTitle,
  onSetTemplate,
  onPickProgram,
  onRemovePickedProgram,
  onReorderPickedProgram,
  onFetchPrograms,
  onSubmit,
}) {
  const handleChange = (e) => {
    if (e.target.name === "highlightTitle") {
      onSetTitle(e.target.value);
    } else if (e.target.name === "template") {
      onSetTemplate(parseInt(e.target.value, 10));
    }
  };
  const handleSearch = (e) => {
    e.preventDefault();
    const { searchText } = e.target.elements;
    onFetchPrograms(searchText.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };
  const layout = templateList.find((t) => t.id === template);
  return (
    <div className="my-8 text-gray-700">
      <Header></Header>
      <div className="mt-8">
        <div>
          <div>
            <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label
                  htmlFor="title"
                  className="block text-sm font-medium leading-5 text-gray-700"
                >
                  Title
                </label>
                <div className="mt-1 rounded-md shadow-sm">
                  <input
                    id="title"
                    name="highlightTitle"
                    className="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    onChange={handleChange}
                  />
                </div>
                <p className="mt-2 text-sm text-gray-500">Required</p>
              </div>
              <div className="sm:col-span-3">
                <label
                  htmlFor="template"
                  className="block text-sm font-medium leading-5 text-gray-700"
                >
                  Layout
                </label>
                <div className="mt-1 rounded-md shadow-sm">
                  <select
                    id="template"
                    name="template"
                    className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    onChange={handleChange}
                  >
                    {templateList.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.title}
                      </option>
                    ))}
                  </select>
                  <img src={layout ? layout.image : ""} alt={template} />
                </div>
                <p className="mt-2 text-sm text-gray-500">Required</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex mt-4">
          <div className="w-1/2">
            <div className="border-b p-1">
              <span className="text-gray-700 text-sm">Shelf</span>
            </div>
            <ul className="p-0 mt-2">
              {pickedPrograms.map((p, index) => (
                <PickedRow
                  key={`${p.content_type}-${p.id}`}
                  program={p}
                  index={index}
                  lastIndex={pickedPrograms.length - 1}
                  onRemovePickedProgram={onRemovePickedProgram}
                  onReorderPickedProgram={onReorderPickedProgram}
                />
              ))}
            </ul>
          </div>
          <div className="w-1/2">
            <div className="border-b p-1">
              <span className="text-gray-700 text-sm">Available Program</span>
            </div>
            <form onSubmit={handleSearch} className="mt-2">
              <label htmlFor="searchText" className="sr-only">
                Search
              </label>
              <div className="flex rounded-md shadow-sm">
                <div className="relative flex-grow focus-within:z-10">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    {/* Heroicon name: search */}
                    <svg
                      className="h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <input
                    id="searchText"
                    name="searchText"
                    className="hidden form-input w-full rounded-none rounded-l-md pl-10 transition ease-in-out duration-150 sm:block sm:text-sm sm:leading-5"
                    placeholder="Search program"
                  />
                </div>
                <button
                  type="submit"
                  className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                >
                  <span className="ml-2">Search</span>
                </button>
              </div>
            </form>
            <ul className="p-0">
              <li className="p-1"></li>
              {programs.map((p, index) => (
                <AvailableRow
                  key={`${p.content_type}-${p.id}`}
                  program={p}
                  onPickProgram={onPickProgram}
                />
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-5">
          <div className="flex justify-end">
            <span className="inline-flex rounded-md shadow-sm">
              <Link
                to="/series-shelf"
                className="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
              >
                Cancel
              </Link>
            </span>
            <span className="ml-3 inline-flex rounded-md shadow-sm">
              <button
                type="button"
                className={c(
                  "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none bg-orange-500 hover:bg-orange-400 text-white focus:border-orange-600 focus:shadow-outline-orange active:bg-orange-600 transition duration-150 ease-in-out"
                )}
                onClick={handleSubmit}
              >
                Create
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Header() {
  return (
    <div className="pb-5 border-b border-gray-200">
      <h3 className="text-lg leading-6 font-medium text-gray-900">
        Create New Shelf
      </h3>
    </div>
  );
}

function PickedRow({
  program,
  index,
  lastIndex,
  onRemovePickedProgram,
  onReorderPickedProgram,
}) {
  return (
    <li className="p-1">
      <div className="flex items-center justify-between">
        <div className="flex w-full items-center">
          <div className="flex items-center">
            {index !== 0 && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onReorderPickedProgram(program, index, index - 1);
                }}
                className="text-gray-900 p-1 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
              >
                <icons.ArrowCircleUp></icons.ArrowCircleUp>
              </button>
            )}
            {index !== lastIndex && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onReorderPickedProgram(program, index, index + 1);
                }}
                className="text-gray-900 p-1 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
              >
                <icons.ArrowCircleDown></icons.ArrowCircleDown>
              </button>
            )}
          </div>

          <span className="text-sm text-gray-900 mx-4">{program.title}</span>
        </div>
        <button
          onClick={(e) => {
            e.preventDefault();
            onRemovePickedProgram(program);
          }}
          className="text-gray-900 p-1 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
        >
          <icons.ArrowCircleRight></icons.ArrowCircleRight>
        </button>
      </div>
    </li>
  );
}

function AvailableRow({ program, onPickProgram }) {
  return (
    <li className="p-1">
      <div className="flex items-center">
        <button
          onClick={(e) => {
            e.preventDefault();
            onPickProgram(program);
          }}
          className="text-gray-900 p-1 cursor-pointer hover:text-orange-500 transition duration-150 ease-in-out focus:outline-none active:outline-none"
        >
          <icons.ArrowCircleLeft></icons.ArrowCircleLeft>
        </button>
        <span className="text-sm text-gray-900 ml-4">{program.title}</span>
      </div>
    </li>
  );
}
